/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Artifact_Visitor_Login_QuotaInputs */



/**
* | output |
* | --- |
* | "{used} of {limit} sign-in links used — saving a change to these settings starts a fresh allowance" |
*
* @param {Artifact_Visitor_Login_QuotaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_visitor_login_quota = /** @type {((inputs: Artifact_Visitor_Login_QuotaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Visitor_Login_QuotaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.used} von ${i?.limit} Anmeldelinks verwendet — beim Speichern einer Änderung dieser Einstellungen beginnt ein neues Kontingent`)
	return /** @type {LocalizedString} */ (`${i?.used} of ${i?.limit} sign-in links used — saving a change to these settings starts a fresh allowance`)
});